import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the issues list, keyed on status, range and order, so switching any of them re-keys THIS
// match and not the page above it — which paints its skeleton at `pendingMs: 0` and would take the toolbar with it. No
// component: nothing to code-split, nothing painted on a re-key. The page reads it with `useMatch({ from })`.
export const Route = createFileRoute('/_app/admin/errors/_list')({
  loaderDeps: ({ search }) => ({
    status: search.errorStatus,
    range: search.errorRange,
    sort: search.errorSort,
  }),
  context: ({ deps }) => ({
    errorIssuesQueryOptions: trpc.admin.listErrorIssues.queryOptions(deps),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.errorIssuesQueryOptions).catch(noop)
  },
})
